module.exports = __webpack_public_path__ + "static/media/import.989d18dc.svg";